<template>
  <svg class="block mx-auto max-w-full" viewBox="0 0 920 155">
    <!-- outlined text -->
    <text
      y="75"
      x="460"
      fill="transparent"
      stroke="currentColor"
      stroke-width="2"
      class="text-8xl font-display"
      text-anchor="middle"
    >
      BONO AMFF-FILMIN
    </text>

    <!-- regular text -->
    <text
      y="150"
      x="460"
      fill="currentColor"
      stroke="transparent"
      class="text-8xl font-display"
      text-anchor="middle"
    >
      BONO AMFF-FILMIN
    </text>
  </svg>
</template>
